import React, { useRef, useEffect } from 'react';
import { Sharing, WhishlistButton } from '@redturtle/iovisit-theme/components/Views';

interface PageActionsProps {
  content: Record<string, any>;
  showWhishlist?: boolean;
  showLabel?: boolean;
}

const PageActions: React.FC<PageActionsProps> = ({
  content,
  showWhishlist = true,
  showLabel = false,
}) => {
  const actionsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Forza il menu sharing a stare dentro il contenitore se troppo vicino al bordo destro
    const dropdown = actionsRef.current?.querySelector(
      '.page-share .ui.dropdown .menu',
    ) as HTMLElement;
    if (dropdown) {
      dropdown.style.right = '0';
      dropdown.style.left = 'auto';
    }
  }, []);

  if (!content) return null;

  return (
    <div
      className="page-actions"
      ref={actionsRef}
      style={{ position: 'relative' }}
    >
      {showWhishlist && typeof window !== 'undefined' && (
        <WhishlistButton id={content['UID']} showLabel={showLabel} />
      )}
      <div className="page-share" style={{ position: 'relative' }}>
        <Sharing
          url={content['@id']}
          title={content.title}
          showLabel={showLabel}
        />
      </div>
    </div>
  );
};

export default PageActions;
